import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined";
import LocalPoliceOutlinedIcon from "@mui/icons-material/LocalPoliceOutlined";
import PeopleAltOutlinedIcon from "@mui/icons-material/PeopleAltOutlined";
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import GridViewIcon from "@mui/icons-material/GridView";
import HandshakeOutlinedIcon  from "@mui/icons-material/HandshakeOutlined";

import * as PATH from "./paths";

const MenuItems = [
  {
    title: "Dashboard",
    icon: GridViewIcon,
    link: PATH.DASHBOARD_PATH,
  },
  {
    title: "Partners",
    icon: HandshakeOutlinedIcon ,
    link: PATH.PARTNER_PATH,
  },
  {
    title: "Blood Requests",
    icon: ArticleOutlinedIcon,
    link: PATH.REQUESTS_PATH,
  },
  {
    title: "Users",
    icon: PeopleAltOutlinedIcon,
    link: PATH.USERS_PATH,
  },
  {
    title: "Badges",
    icon: LocalPoliceOutlinedIcon,
    link: PATH.BADGES_PATH,
  },
  {
    title: "Events",
    icon: EmojiEventsIcon,
    link: PATH.EVENTS_PATH,
  },
];

export default MenuItems;
